/**
 * 菜单管理主页面（精简版，仅保留：菜单结构、角色可见性）
 */
import React, { useState } from 'react';
import { Tabs } from 'antd';
import { MenuOutlined, SettingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import MenuStructureManagement from './MenuStructureManagement';
import RoleConfigManagement from './RoleConfigManagement';

const MenuManagement: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('role-config');

  return (
    <div className="menu-management" style={{ width: '100%', maxWidth: '100%', minWidth: 0, overflowX: 'hidden' }}>
      <h1 className="text-2xl font-bold text-gray-800">{t('menu.menuManagement')}</h1>
      <p className="text-gray-600 mt-2">{t('menu.manageMenuStructure')}</p>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: 'menu-structure',
            label: (
              <span>
                <MenuOutlined />
                菜单结构
              </span>
            ),
            children: (
              <div style={{ minWidth: 0 }}>
                <div style={{ marginBottom: 16, padding: 16, background: '#f5f5f5', borderRadius: 6 }}>
                  <h4>📁 菜单结构管理说明</h4>
                  <p>
                    管理菜单的层级结构、路径、图标等。权限通过 permission_code 绑定到权限系统。
                    提示：此处配置的菜单“中/英文名称”仅作用于左侧导航显示；右侧标签页标题仍通过国际化 key 渲染（TabsManager 使用 i18n 映射）。
                  </p>
                </div>
                <MenuStructureManagement />
              </div>
            )
          },
          {
            key: 'role-config',
            label: (
              <span>
                <SettingOutlined />
                角色可见性
              </span>
            ),
            children: (
              <div style={{ minWidth: 0 }}>
                <div style={{ marginBottom: 16, padding: 16, background: '#f5f5f5', borderRadius: 6 }}>
                  <h4>⚙️ 角色配置说明</h4>
                  <p>
                    为不同角色配置菜单可见性。选择角色后，可以设置该角色可以看到哪些菜单；每个菜单一行，勾选列表示对应角色可见；可覆盖该角色访问路径。
                  </p>
                </div>
                <RoleConfigManagement />
              </div>
            )
          }
        ]}
      />
    </div>
  );
};

export default MenuManagement;
